import AntPagination from 'antd-core/es/pagination';
import styled from 'styled-components';

const PaginationButton = styled.span.attrs({
    $variant: {
        medium: '32px',
        small: '24px',
    },
}) `
  display: inline-block;
  width: ${props => props.$variant[props.$size]};
  height: ${props => props.$variant[props.$size]};
  border-radius: 8px;

  &:hover {
    color: ${props => props.theme.colors.blue500};
    background-color: ${props => props.theme.colors.blue50};
  }

  &:active {
    background-color: ${props => props.theme.colors.blue100};
    color: ${props => props.theme.colors.blue700};
  }
`;
const Root = styled(AntPagination) `
  &.tend-ui-pagination {
    display: flex;

    .tend-ui-pagination-options {
      width: 100%;
      display: inline-flex;
      flex-direction: row-reverse;
      justify-content: space-between;
    }

    .tend-ui-pagination-item {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .tend-ui-pagination-item:not(.tend-ui-pagination-item-active) {
      &:hover {
        a {
          color: ${props => props.$theme.colors.blue500};
        }
      }

      &:active {
        background-color: ${props => props.$theme.colors.blue100};
        a {
          color: ${props => props.$theme.colors.blue700};
        }
      }
    }

    .tend-ui-pagination-item-active {
      a {
        font-weight: 400;
        color: white;
      }

      &:hover {
        border-color: ${props => props.$theme.colors.blue600};

        a {
          color: white;
        }
      }
    }
  }
`;

export { PaginationButton, Root };
